import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import { Button } from 'shared/ui/Button';
import BlackFridayBanner from 'shared/assets/images/BlackFridayBanner.png';
import BlackFridayMobile from 'shared/assets/images/BlackFridayMobile.png';
import { Trans } from 'react-i18next';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

export const BlackFridayPromotionContent: FC = memo(() => {
  const { t } = useAppTranslation('booking');

  const navigate = useNavigate();
  const { isDesktop } = useScreenBreakpoints();

  const { data } = useGetRentOptionsQuery({ isSpecialPromotion: true });
  // const currencySymbol = useGetCurrencySymbol();
  const { closeModal } = useSpecialPromotionModal();

  const goToBooking = useCallback(() => {
    navigate(data?.length ? `${AppRoutes.BOOKING}?rentOptionId=${data[0].rentOptionId}` : AppRoutes.BOOKING);
    closeModal();
  }, [closeModal, data, navigate]);

  return (
    <div>
      <img src={isDesktop ? BlackFridayBanner : BlackFridayMobile} alt="Black friday promotion" className="min-h-[450px]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[280px] desktop:max-w-[675px] w-full bg-white p-6 desktop:p-10 text-center shadow-xl rounded-xl">
        {/* <div className="mb-3 flex justify-end">
          <Button theme="clear" className="text-black" onClick={closeModal}>
            {t('Close')}
          </Button>
        </div> */}
        <div className="mb-7 text-[#EB1010] font-bold text-2xl desktop:text-4xl uppercase">{t('BLACK FRIDAY THAT LASTS 330 DAYS!')}</div>
        <div className="font-normal text-lg desktop:text-2xl text-black px-4">
          <Trans
            t={t}
            i18nKey="Only until <0>01.12:</0> <1>28% off for 11 months</1>"
            components={[
              <span key="0" className="font-bold text-lg desktop:text-2xl text-black" />,
              <span key="1" className="font-bold text-lg desktop:text-2xl text-primary underline decoration-wavy" />,
            ]}
          />
        </div>
        <div className="font-normal text-lg desktop:text-2xl text-black mb-2">{t('All units – all locations!')}</div>
        <div className="text-primaryLight italic mb-7 font-normal text-sm desktop:text-base">
          {t('Minimum rental period: 1 month – contract start date can be chosen at any time')}
        </div>
        <Button theme="dark" fontSize={isDesktop ? 'large' : 'small'} onClick={goToBooking}>
          {t('Book now and secure the special price!')}
        </Button>
      </div>
    </div>
  );
});
